/*
 * This file is autogenerated don't change it manually
 */

const actions = {

    "add-$$form": async function(action, args){
        const module = await import("@/components/forms/actions/Actions");
        await module.addEntityInForm.apply(action, args);
    },

    "add-$role-role-to-$applicationuser": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addRoleToUser.apply(action, args);
    },

    "add-attachment-to-$applicationuser": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addAttachmentToUser.apply(action, args);
    },

    "add-attachment-to-my-profile": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addAttachmentToMyProfile.apply(action, args);
    },

    "add-sticky-note": async function(action, args){
        const module = await import("@/components/sticky/Actions");
        await module.addStickyNote.apply(action, args);
    },

    "add-user": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addUser.apply(action, args);
    },

    "change-$applicationuser-password": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.editSelectedUser.apply(action, args);
    },

    "change-$applicationuser-roles": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.changeUserRoles.apply(action, args);
    },

    "change-my-password": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.changeMyPassword.apply(action, args);
    },

    "change-organization-domain": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.changeOrganizationDomain.apply(action, args);
    },

    "change-organization-logo": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.changeOrganization.apply(action, args);
    },

    "change-organization-name": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.changeOrganization.apply(action, args);
    },

    "chat-with-silena": async function(action, args){
        const module = await import("@/components/chatBot/Actions");
        await module.runSilena.apply(action, args);
    },

    "delete-$role-from-$applicationuser": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.deleteRoleFromUser.apply(action, args);
    },

    "delete-attachment-from-$applicationuser": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addAttachmentToUser.apply(action, args);
    },

    "delete-attachment-from-my-profile": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addAttachmentToMyProfile.apply(action, args);
    },

    "edit-$$form": async function(action, args){
        const module = await import("@/components/forms/actions/Actions");
        await module.showList.apply(action, args);
    },

    "edit-$$formentity": async function(action, args){
        const module = await import("@/components/forms/actions/Actions");
        await module.editEntity.apply(action, args);
    },

    "edit-$applicationuser": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.editSelectedUser.apply(action, args);
    },

    "edit-sticky-note": async function(action, args){
        const module = await import("@/components/sticky/Actions");
        await module.showListOfStickyNotes.apply(action, args);
    },

    "remove-$$form": async function(action, args){
        const module = await import("@/components/forms/actions/Actions");
        await module.showList.apply(action, args);
    },

    "remove-$$formentity": async function(action, args){
        const module = await import("@/components/forms/actions/Actions");
        await module.deleteEntityInForm$$FormEntity.apply(action, args);
    },

    "remove-$applicationuser": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.deleteUser.apply(action, args);
    },

    "remove-sticky-note": async function(action, args){
        const module = await import("@/components/sticky/Actions");
        await module.showListOfStickyNotes.apply(action, args);
    },

    "remove-user": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.showUsers.apply(action, args);
    },

    "reset-user-password": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.showUsers.apply(action, args);
    },

    "show-$$form": async function(action, args){
        const module = await import("@/components/forms/actions/Actions");
        await module.showList.apply(action, args);
    },

    "show-$applicationuser-attachments": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addAttachmentToUser.apply(action, args);
    },

    "show-my-attachments": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.addAttachmentToMyProfile.apply(action, args);
    },

    "show-notifications": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.showNotifications.apply(action, args);
    },

    "show-sticky-notes": async function(action, args){
        const module = await import("@/components/sticky/Actions");
        await module.showListOfStickyNotes.apply(action, args);
    },

    "show-users": async function(action, args){
        const module = await import("@/components/users/Actions");
        await module.showUsers.apply(action, args);
    },

}

export default actions;
